const NoDataFound = ({ message = "No Data Found" }) => {
  return (
    <div className="flex items-center justify-center w-full">
      <div className="p-4 rounded-md text-slate-400 text-center">{message}</div>
    </div>
  );
};

export default NoDataFound;
